<template>
  <div id="container">
    <!-- AI-inspired animated background elements -->
    <div class="ai-background">
      <div class="floating-particles">
        <div class="particle" v-for="n in 20" :key="n" :style="getParticleStyle(n)"></div>
      </div>
      <div class="neural-network">
        <div class="node" v-for="n in 15" :key="n" :style="getNodeStyle(n)"></div>
        <svg class="connections" viewBox="0 0 100 100">
          <line x1="20" y1="20" x2="80" y2="30" class="connection-line" />
          <line x1="30" y1="40" x2="70" y2="60" class="connection-line" />
          <line x1="15" y1="70" x2="85" y2="25" class="connection-line" />
          <line x1="40" y1="80" x2="60" y2="15" class="connection-line" />
          <line x1="60" y1="40" x2="25" y2="75" class="connection-line" />
          <line x1="75" y1="80" x2="35" y2="20" class="connection-line" />
          <line x1="10" y1="30" x2="90" y2="70" class="connection-line" />
          <line x1="50" y1="10" x2="20" y2="90" class="connection-line" />
        </svg>
      </div>
      <div class="geometric-shapes">
        <div class="shape triangle"></div>
        <div class="shape circle"></div>
        <div class="shape hexagon"></div>
        <div class="shape diamond"></div>
        <div class="shape pentagon"></div>
      </div>
    </div>
    
    <v-snackbar :timeout="5000" :value="snack" absolute top :color="scolor" outlined center>
      {{stext}}
    </v-snackbar>

    <div class="content-wrapper">
      <!-- Brand Elements Positioned Around Login Card -->
      <div class="brand-elements">
        <!-- Top Brand Title -->
        <div class="brand-title-top">
          <h1 class="main-brand-title">DeepTrack</h1>
          <p class="main-brand-subtitle">Ultimate Project Management Platform</p>
          
          <!-- Industry Service Badges -->
          <div class="service-badges">
            <div class="service-badge" title="ACMV Solutions">
              <span class="badge-icon">🏢</span>
              <span class="badge-text">ACMV</span>
            </div>
            <div class="service-badge" title="Fire Fighting Systems">
              <span class="badge-icon">🔥</span>
              <span class="badge-text">Fire Safety</span>
            </div>
            <div class="service-badge" title="Extra Low Voltage Solutions">
              <span class="badge-icon">⚡</span>
              <span class="badge-text">ELV</span>
            </div>
            <div class="service-badge" title="Architecture & Automation">
              <span class="badge-icon">🏗️</span>
              <span class="badge-text">A&A</span>
            </div>
          </div>
        </div>
      </div>
      
      <div id="page-card">
        <div class="logo-section">
          <div class="logo-icon-large">
            <img src="/Deepcost_Logo.png" alt="DeepTrack Logo" class="logo-image" />
          </div>
        </div>
        
        <div class="page-header">
          <h2>Welcome Back</h2>
          <p class="login-subtitle">Sign in to continue to DeepTrack</p>
        </div>

        <v-tabs v-model="tabs" @change="close" centered background-color="transparent">
            <v-tabs-slider color="#02A5C0"></v-tabs-slider>
            <v-tab>Login</v-tab>
            <!-- <v-tab>Register</v-tab> -->
        </v-tabs>
        <v-tabs-items v-model="tabs" class="transparent-tabs">
          <v-tab-item>
            <v-form @submit.prevent="login">
              <div class="input-group">
                <label>Email</label>
                <div class="input-wrapper">
                  <v-icon class="input-icon">mdi-account</v-icon>
                  <v-text-field solo flat hide-details :rules="emailRules" v-model="email" placeholder="soma@newhamtech.com" required></v-text-field>
                </div>
              </div>

              <div class="input-group">
                <label>Password</label>
                <div class="input-wrapper">
                  <v-icon class="input-icon">mdi-lock</v-icon>
                  <v-text-field solo flat hide-details :rules="req" :type="showPassword ? 'text' : 'password'" v-model="password" placeholder="••••••" required></v-text-field>
                  <span v-if="password" class="toggle-icon" @click="togglePassword">
                    <v-icon>{{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                  </span>
                </div>
              </div>
              
              <div class="form-options">
                <a @click="resetDialog = true" class="forgot-password-link">Forgot Password?</a>
              </div>

              <div id="button-group">
                <v-btn @click="login" :loading="loading" type="submit" id="login-button" v-action-process>LOGIN</v-btn>
              </div>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form @submit.prevent="register">
                <div class="input-group">
                  <label>Name</label>
                  <div class="input-wrapper">
                      <v-icon class="input-icon">mdi-account</v-icon>
                      <v-text-field solo flat hide-details label="Name" :rules="req" v-model="name"></v-text-field>
                  </div>
                </div>
                <div class="input-group">
                  <label>Email</label>
                  <div class="input-wrapper">
                      <v-icon class="input-icon">mdi-email</v-icon>
                      <v-text-field solo flat hide-details label="Email" :rules="emailRules" v-model="email"></v-text-field>
                  </div>
                </div>
                <div class="input-group">
                  <label>Password</label>
                  <div class="input-wrapper">
                      <v-icon class="input-icon">mdi-lock</v-icon>
                      <v-text-field solo flat hide-details label="Password" :rules="req" type="password" v-model="password"></v-text-field>
                  </div>
                </div>
                <div class="input-group">
                  <label>Confirm Password</label>
                  <div class="input-wrapper">
                      <v-icon class="input-icon">mdi-lock-outline</v-icon>
                      <v-text-field solo flat hide-details label="Confirm Password" :rules="passMatch" type="password" v-model="rpassword"></v-text-field>
                  </div>
                </div>
                <div id="button-group" class="mt-4">
                  <v-btn block large @click="register" :loading="loading" id="login-button" v-action-process> Register </v-btn>
                </div>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>

    <!-- Dialogs -->
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card>
            <v-card-title>Please Confirm Your Email</v-card-title>
            <v-card-text>
                <p>We have sent a confirmation email to {{email}}. Please check your inbox and click on the confirmation link to complete your registration.</p>
                <v-btn color="primary" @click="close">Close</v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="resetDialog" max-width="500px" persistent>
        <v-card>
            <v-card-title>Reset Password</v-card-title>
            <v-card-text>
                <p>Enter your email address and we will send you a link to reset your password.</p>
                <v-form>
                    <v-text-field label="Email" filled prepend-inner-icon="mdi-email" :rules="emailRules" v-model="resetEmail"></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeResetDialog">Cancel</v-btn>
                <v-btn color="primary" @click="handlePasswordReset" :loading="loading">Send Reset Link</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
     <v-dialog v-model="updatePasswordDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>Update Password</v-card-title>
        <v-card-text>
          <p>Enter your new password.</p>
          <v-form>
            <v-text-field label="New Password" v-model="newPassword" type="password" :rules="req"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="updatePasswordDialog = false" v-action-process>Cancel</v-btn>
          <v-btn color="primary" @click="updatePassword" :loading="loading" v-action-process>Update Password</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/services/api'

export default {
    data: () => ({
        tabs: null,
        name: '',
        email: '',
        emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'Enter valid email address',
        ],
        req: [
            v => !!v || 'This field is required',
        ],
        password: '',
        rpassword: '',
        loading: false,
        snack: false,
        scolor: '',
        stext: '',
        dialog: false,
        resetDialog: false,
        resetEmail: '',
        showPassword: false,
        rememberMe: false,
        updatePasswordDialog: false,
        newPassword: '',
    }),

    methods: {
        async login() {
            this.loading = true
            try {
                const data = await api.auth.login({
                    email: this.email,
                    password: this.password
                });
                
                if (data.user) {
                    if (data.user.active) {
                        this.snack = true;
                        this.scolor = 'success';
                        this.stext = 'Logged In';
                        this.loading = false;
                        this.$router.push('/');
                    } else {
                        await api.auth.logout();
                        this.snack = true;
                        this.scolor = 'error';
                        this.stext = 'Your account is deactivated. Please contact an administrator.';
                        this.loading = false;
                    }
                } else {
                    throw new Error('Invalid response from server');
                }
            } catch (error) {
                console.error(error);
                this.snack = true;
                this.scolor = 'error';
                this.stext = error.response?.data?.error || 'An unexpected error occurred during login.';
                this.loading = false;
            }
        },

        async register () {
            this.loading = true
            try {
                await api.auth.signup({
                    email: this.email,
                    password: this.password,
                    name: this.name
                });
                
                this.snack = true
                this.scolor = 'success'
                this.stext = 'User registered successfully!'
                this.loading = false
                this.dialog = true // Note: You might want to remove "Confirm Email" dialog if you don't send emails
            } catch (error) {
                this.snack = true
                this.scolor = 'error'
                this.stext = error.response?.data?.error || error.message
                this.loading = false
            }
        },

        async handlePasswordReset() {
            this.loading = true;
            try {
                await api.auth.resetPassword(this.resetEmail);
                this.snack = true;
                this.scolor = 'success';
                this.stext = 'Password reset link sent (if implemented).';
                this.closeResetDialog();
            } catch (error) {
                 this.snack = true;
                 this.scolor = 'error';
                 this.stext = error.response?.data?.error || 'Error sending reset link';
            }
            this.loading = false;
        },
        async updatePassword() {
            this.loading = true;
            try {
                 await api.auth.updateUser({ password: this.newPassword });
                 this.snack = true;
                 this.scolor = 'success';
                 this.stext = 'Password updated successfully.';
                 this.updatePasswordDialog = false;
                 this.newPassword = '';
            } catch (error) {
                 this.snack = true;
                 this.scolor = 'error';
                 this.stext = error.response?.data?.error || 'Error updating password';
            }
            this.loading = false;
        },

        closeResetDialog() {
            this.resetDialog = false;
            this.resetEmail = '';
        },

        close() {
            this.email = ''
            this.password = ''
            this.name = ''   
            this.rpassword = ''
            this.loading = false
            this.dialog = false
        },

        togglePassword() {
          this.showPassword = !this.showPassword;
        },

        getParticleStyle(index) {
          const positions = [
            { left: '10%', top: '20%', animationDelay: '0s' },
            { left: '85%', top: '15%', animationDelay: '1s' },
            { left: '20%', top: '80%', animationDelay: '2s' },
            { left: '75%', top: '70%', animationDelay: '0.5s' },
            { left: '45%', top: '10%', animationDelay: '1.5s' },
            { left: '90%', top: '50%', animationDelay: '3s' },
            { left: '5%', top: '60%', animationDelay: '2.5s' },
            { left: '60%', top: '85%', animationDelay: '0.8s' },
            { left: '30%', top: '30%', animationDelay: '1.8s' },
            { left: '70%', top: '25%', animationDelay: '2.2s' },
            { left: '15%', top: '45%', animationDelay: '3.5s' },
            { left: '80%', top: '90%', animationDelay: '1.2s' }
          ];
          return positions[index - 1] || positions[0];
        },

        getNodeStyle(index) {
          const positions = [
            { left: '20%', top: '20%', animationDelay: '0s' },
            { left: '80%', top: '30%', animationDelay: '0.5s' },
            { left: '30%', top: '40%', animationDelay: '1s' },
            { left: '70%', top: '60%', animationDelay: '1.5s' },
            { left: '15%', top: '70%', animationDelay: '2s' },
            { left: '85%', top: '25%', animationDelay: '2.5s' },
            { left: '40%', top: '80%', animationDelay: '3s' },
            { left: '60%', top: '15%', animationDelay: '3.5s' }
          ];
          return positions[index - 1] || positions[0];
        },

        animateCounters() {
          setTimeout(() => {
            this.animateCounter('projectCounter', 1247, 2000);
            this.animateCounter('timeCounter', 3420, 2500);
          }, 1000);
        },

        animateCounter(refName, target, duration) {
          const element = this.$refs[refName];
          if (!element) return; 
          
          const start = 0;
          const increment = target / (duration / 16);
          let current = start;
          
          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              element.textContent = target.toLocaleString();
              clearInterval(timer);
            } else {
              element.textContent = Math.floor(current).toLocaleString();
            }
          }, 16);
        }
    },

    mounted() {
        if (this.$route.query.message) {
            this.stext = this.$route.query.message;
            this.scolor = 'error';
            this.snack = true;
        }
        this.animateCounters();
    },

    computed: {
        passMatch () {
            return [v => (!!v && v) === this.password ||'Values do not match']
        }
    }
}
</script>

<style scoped>
/* CSS Reset for this component */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Container settings */
#container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(135deg, #000508 0%, #001014 25%, #001a1f 50%, #001014 75%, #000508 100%);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
  position: relative;
  overflow: hidden;
}

.content-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  z-index: 5;
  padding: 0 2rem;
}

/* Enhanced AI Background Shapes */
.diamond {
  width: 25px;
  height: 25px;
  background: rgba(2, 165, 192, 0.2);
  transform: rotate(45deg);
  top: 15%;
  left: 80%;
  animation: rotate 40s linear infinite;
}

.pentagon {
  width: 30px;
  height: 30px;
  background: rgba(2, 165, 192, 0.15);
  clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
  top: 85%;
  right: 25%;
  animation: rotate 45s linear infinite reverse;
}

/* Brand Elements Positioned Around Login Card */
.brand-elements {
  position: relative;
  pointer-events: none;
  z-index: 5;
  flex: 0 1 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.brand-title-top {
  position: relative;
  text-align: center;
  z-index: 20;
  width: 100%;
}

.main-brand-title {
  font-size: 64px;
  font-weight: 900;
  color: #ffffff;
  margin: 0 0 8px 0;
  text-shadow: 0 6px 30px rgba(2, 165, 192, 0.6);
  letter-spacing: -2px;
  animation: textGlow 4s ease-in-out infinite alternate, titleFloat 6s ease-in-out infinite;
}

.main-brand-subtitle {
  font-size: 20px;
  color: rgba(2, 165, 192, 0.9);
  margin: 0;
  font-weight: 400;
  letter-spacing: 1px;
  animation: subtitleGlow 3s ease-in-out infinite alternate;
}

/* Service Badges */
.service-badges {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 20;
  width: 280px;
  margin: 40px auto 0;
}

.service-badge {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: rgba(2, 165, 192, 0.12);
  border: 1px solid rgba(2, 165, 192, 0.3);
  border-radius: 16px;
  backdrop-filter: blur(15px);
  transition: all 0.3s ease;
  animation: badgeFloat 4s ease-in-out infinite;
  min-width: 200px;
}

.service-badge:nth-child(1) { animation-delay: 0s; }
.service-badge:nth-child(2) { animation-delay: 0.5s; }
.service-badge:nth-child(3) { animation-delay: 1s; }
.service-badge:nth-child(4) { animation-delay: 1.5s; }

.service-badge:hover {
  transform: translateY(-2px);
  background: rgba(2, 165, 192, 0.15);
  border-color: rgba(2, 165, 192, 0.5);
  box-shadow: 0 4px 15px rgba(2, 165, 192, 0.2);
}

.badge-icon {
  font-size: 16px;
}

.badge-text {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Login Card */
#login-card {
  background: rgba(0, 93, 108, 0.15);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(2, 165, 192, 0.2);
  border-radius: 24px;
  padding: 48px;
  width: 100%;
  max-width: 440px;
  box-shadow: 
    0 25px 50px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 10;
  animation: cardFloat 6s ease-in-out infinite, cardGlow 4s ease-in-out infinite alternate;
  transition: all 0.3s ease;
  text-align: center;
  flex: 0 1 50%;
}

.logo-section {
  margin-bottom: 24px;
}

.logo-icon-large {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: linear-gradient(145deg, rgba(2, 165, 192, 0.15) 0%, rgba(0, 93, 108, 0.08) 100%);
  border: 2px solid rgba(2, 165, 192, 0.3);
  border-radius: 16px;
  margin-bottom: 12px;
  animation: logoFloat 4s ease-in-out infinite, logoPulse 6s ease-in-out infinite;
  box-shadow: 0 10px 20px rgba(2, 165, 192, 0.2);
}

.logo-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
  filter: drop-shadow(0 4px 20px rgba(2, 165, 192, 0.4));
  transition: all 0.3s ease;
}

.logo-image:hover {
  filter: drop-shadow(0 4px 20px rgba(2, 165, 192, 0.7));
  transform: scale(1.05);
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.login-header h2 {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 10px rgba(2, 165, 192, 0.3);
}

.login-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  font-weight: 400;
}

/* Input Group */
.input-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: left;
}

.input-group label {
  margin-bottom: 8px;
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.input-wrapper .v-text-field {
  padding: 0;
}

.input-wrapper >>> .v-input__control > .v-input__slot {
  padding: 12px 16px 12px 45px !important;
  background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 4px !important;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  color: #333 !important;
  transition: all 0.3s ease;
  box-shadow: none !important;
}

.input-wrapper >>> .v-text-field__slot input {
  color: #333 !important;
}

.input-wrapper >>> .v-text-field__slot input::placeholder {
  color: rgba(0, 0, 0, 0.5) !important;
  opacity: 1;
}

.input-wrapper >>> .v-input--is-focused .v-input__control > .v-input__slot {
  border-color: #02A5C0 !important;
  box-shadow: 0 0 0 2px rgba(2, 165, 192, 0.2) !important;
}

.input-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.5) !important;
  font-size: 18px !important;
  z-index: 2;
}

.input-wrapper:focus-within .input-icon {
  color: #02A5C0 !important;
}

.toggle-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5);
  font-size: 14px;
  transition: color 0.2s ease;
  z-index: 2;
}

.toggle-icon:hover {
  color: #02A5C0;
}

/* Form Options */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  font-size: 14px;
}

.remember-me {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  user-select: none;
}

.remember-me input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 16px;
  height: 16px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
  transition: all 0.2s ease;
}

.remember-me input[type="checkbox"]:checked + .checkmark {
  background-color: #02A5C0;
  border-color: #02A5C0;
}

.remember-me input[type="checkbox"]:checked + .checkmark::after {
  content: '✓';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 10px;
  font-weight: bold;
}

.forgot-password-link {
  color: #02A5C0;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
  cursor: pointer;
}

.forgot-password-link:hover {
  color: #005D6C;
  text-decoration: underline;
}

/* Button Group */
#button-group {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

#login-button {
  padding: 22px 0 !important;
  background: #02A5C0 !important;
  color: white !important;
  border: none;
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  text-transform: uppercase;
}

#login-button:hover {
  background: #005D6C !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(2, 165, 192, 0.3);
}

#login-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(2, 165, 192, 0.2);
}

/* Vuetify Tabs Override */
.v-tab {
  color: rgba(255, 255, 255, 0.7) !important;
  font-weight: 500;
  text-transform: uppercase;
}
.v-tab--active {
  color: #ffffff !important;
}
.transparent-tabs {
  background-color: transparent !important;
}


/* Responsive adjustments */
@media (max-width: 1200px) {
    .content-wrapper {
        flex-direction: column;
        gap: 2rem;
    }
    .brand-elements {
        display: none;
    }
}

@media (max-width: 768px) {
  #container {
    padding: 20px;
  }

  #login-card {
    padding: 30px 25px;
    max-width: 100%;
  }
  .brand-elements {
      display: none;
  }
}

/* AI Background Animations */
.ai-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.floating-particles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: rgba(2, 165, 192, 0.6);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
  box-shadow: 0 0 10px rgba(2, 165, 192, 0.3);
}

.neural-network {
  position: absolute;
  width: 100%;
  height: 100%;
}

.node {
  position: absolute;
  width: 8px;
  height: 8px;
  background: rgba(2, 165, 192, 0.8);
  border-radius: 50%;
  animation: pulse 3s ease-in-out infinite;
  box-shadow: 0 0 15px rgba(2, 165, 192, 0.5);
}

.connections {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.3;
}

.connection-line {
  stroke: rgba(2, 165, 192, 0.4);
  stroke-width: 0.5;
  animation: connectionPulse 4s ease-in-out infinite;
}

.geometric-shapes {
  position: absolute;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  opacity: 0.1;
  animation: rotate 20s linear infinite;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 30px solid transparent;
  border-right: 30px solid transparent;
  border-bottom: 50px solid rgba(2, 165, 192, 0.3);
  top: 20%;
  right: 10%;
  animation: rotate 25s linear infinite;
}

.circle {
  width: 40px;
  height: 40px;
  border: 2px solid rgba(2, 165, 192, 0.3);
  border-radius: 50%;
  top: 70%;
  left: 15%;
  animation: rotate 30s linear infinite reverse;
}

.hexagon {
  width: 30px;
  height: 17px;
  background: rgba(2, 165, 192, 0.2);
  position: relative;
  top: 40%;
  right: 20%;
  animation: rotate 35s linear infinite;
}

.hexagon:before,
.hexagon:after {
  content: "";
  position: absolute;
  width: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
}

.hexagon:before {
  bottom: 100%;
  border-bottom: 8.5px solid rgba(2, 165, 192, 0.2);
}

.hexagon:after {
  top: 100%;
  border-top: 8.5px solid rgba(2, 165, 192, 0.2);
}

/* Keyframe Animations */
@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) translateX(0px);
    opacity: 0.7;
  }
  25% {
    transform: translateY(-20px) translateX(10px);
    opacity: 1;
  }
  50% {
    transform: translateY(-10px) translateX(-5px);
    opacity: 0.8;
  }
  75% {
    transform: translateY(-15px) translateX(15px);
    opacity: 0.9;
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
}

@keyframes connectionPulse {
  0%, 100% {
    opacity: 0.2;
    stroke-width: 0.5;
  }
  50% {
    opacity: 0.6;
    stroke-width: 1;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes cardFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
}

@keyframes cardGlow {
  0% {
    box-shadow: 
      0 25px 50px rgba(0, 0, 0, 0.4),
      0 0 0 1px rgba(2, 165, 192, 0.1),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  }
  100% {
    box-shadow: 
      0 25px 50px rgba(0, 0, 0, 0.4),
      0 0 0 1px rgba(2, 165, 192, 0.3),
      inset 0 1px 0 rgba(255, 255, 255, 0.1),
      0 0 40px rgba(2, 165, 192, 0.1);
  }
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-4px);
  }
}

@keyframes logoPulse {
  0%, 100% {
    box-shadow: 0 20px 40px rgba(2, 165, 192, 0.2);
  }
  50% {
    box-shadow: 0 20px 40px rgba(2, 165, 192, 0.4);
  }
}

@keyframes textGlow {
  0% {
    text-shadow: 0 4px 20px rgba(2, 165, 192, 0.4);
  }
  100% {
    text-shadow: 0 4px 20px rgba(2, 165, 192, 0.8);
  }
}

@keyframes featureFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-3px);
  }
}

@keyframes shimmer {
  0%, 100% {
    background-position: -200% 0;
  }
  50% {
    background-position: 200% 0;
  }
}

@keyframes titleFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-8px);
  }
}

@keyframes subtitleGlow {
  0% {
    color: rgba(2, 165, 192, 0.9);
  }
  100% {
    color: rgba(2, 165, 192, 1);
  }
}

@keyframes taglineGlow {
  0% {
    color: rgba(255, 255, 255, 0.7);
  }
  100% {
    color: rgba(255, 255, 255, 0.9);
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes badgeFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-3px);
  }
}

@keyframes counterFloat {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes numberGlow {
  0% {
    color: #02A5C0;
    text-shadow: 0 2px 10px rgba(2, 165, 192, 0.4);
  }
  100% {
    color: #02C5E0;
    text-shadow: 0 2px 15px rgba(2, 165, 192, 0.6);
  }
}
</style>